module.exports = __webpack_public_path__ + "images/coupon-icon-get.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/coupon-icon-get.png
// module id = 830
// module chunks = 127